import { Button as MuiButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import CheckInListingButton from './CheckInListingButton'
import CheckOutListingButton from './CheckOutListingButton'
import ExtendListingButton from './ExtendListingButton'
import DrawerActionButton from './DrawerActionButton'
import CheckOutDetailButton from './CheckOutDetailButton'
import BackButton from './BackButton'
import DropdownOptionsButton from './DropdownOptionsButton'

import { Loader } from 'packages/eid-ui'

const styles = {
    small: {
        padding: '0.325rem 2rem',
        minHeight: '3.5rem',
    },
    medium: {
        padding: '0.525rem 1.5rem',
        minHeight: '3.9rem',
    },
    large: {
        padding: '0.925rem 3rem',
        minHeight: '4.7rem',
    },
}

const StyledButton = styled(MuiButton, {
    shouldForwardProp: (prop) =>
        prop !== 'variantStyles' && prop !== 'disabledStyles',
})(({ theme, size, variantStyles, disabledStyles }) => ({
    textTransform: 'capitalize',
    fontSize: '1.6rem',
    border: '0.1rem solid transparent',
    borderRadius: '0.5rem',
    ...variantStyles,
    '& .MuiButton-startIcon': {
        marginRight: size === 'large' ? '1.4rem' : '1rem',
    },
    '&.Mui-disabled': {
        ...disabledStyles,
    },
}))

const EidButton = (props) => {
    const {
        size,
        children,
        style,
        disabledStyles,
        loading,
        loaderColor,
        startIcon,
        endIcon,
        onClick,
        ...rest
    } = props
    const variantStyles = styles[size]

    return (
        <StyledButton
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            size={size}
            variantStyles={variantStyles}
            disabledStyles={disabledStyles}
            onClick={!loading ? onClick : undefined}
            sx={{ whiteSpace: 'nowrap', ...style }}
            {...rest}
        >
            {!loading ? (
                children
            ) : (
                <Loader
                    color={loaderColor ? loaderColor : '#ffffff'}
                    size={0.6}
                    height="0.5inh"
                />
            )}
        </StyledButton>
    )
}

EidButton.CheckInListing = CheckInListingButton
EidButton.CheckOutListing = CheckOutListingButton
EidButton.ExtendListing = ExtendListingButton
EidButton.DrawerActionButton = DrawerActionButton
EidButton.CheckOutDetailButton = CheckOutDetailButton
EidButton.BackButton = BackButton
EidButton.DropdownOptionsButton = DropdownOptionsButton

export default EidButton
